<template>
  <v-flex xs12 sm6 md4 class="pa-2" scroll>
    <v-card :height="height">
      <v-card-title class="title font-weight-light ">{{ title }}</v-card-title>
      <v-card-subtitle class="subtitle">{{ subtitle }}</v-card-subtitle>
      <v-divider />
      <slot></slot>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: "Stat",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "400",
    },
  },
};
</script>

<style scoped>
.scroll {
  overflow-y: auto;
}
</style>
